import { render, staticRenderFns } from "./quote_details.vue?vue&type=template&id=115f98f4&scoped=true&"
import script from "./quote_details.vue?vue&type=script&lang=js&"
export * from "./quote_details.vue?vue&type=script&lang=js&"
import style0 from "./quote_details.vue?vue&type=style&index=0&id=115f98f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f98f4",
  null
  
)

export default component.exports